import { compact, pick } from 'lodash-es';

import {
  CompanyVerificationRequestLegalDocument,
  VerificationMethod,
} from '../../../common/interfaces/entities';
import { LegalDocumentInput } from './hooks/useRequestCompanyVerification';
import { CompanyVerificationFormState } from './types';
import { getAssetFileNameFromURL, isURL } from './utils';

function getFileName(value: string) {
  return isURL(value) ? getAssetFileNameFromURL(value) || '' : value;
}

export function buildLegalDocumentVerificationInput(
  legalDocuments: CompanyVerificationFormState['verifyWithLegalDocuments']
): LegalDocumentInput {
  return {
    verificationMethod: VerificationMethod.LEGAL_DOCUMENTS,
    legalDocumentsData: {
      companyNPWPDoc: legalDocuments.companyNPWPDoc
        ? getFileName(legalDocuments.companyNPWPDoc)
        : null,
      companyNPWPNumber: legalDocuments.legalDocumentNotOfficial
        ? legalDocuments.companyNPWPNumber ?? null
        : null,
      companyNPWPDocMetadata: pick(legalDocuments.companyNPWPDocMetadata, [
        'source',
        'producer',
        'creator',
        'createdAt',
        'modifiedAt',
      ]),
      companyNIBNumber: legalDocuments.companyNIBNumber || null,
      acraBizFile: legalDocuments.acraBizFile
        ? getFileName(legalDocuments.acraBizFile)
        : null,
      companyUniqueEntityNumber:
        legalDocuments.companyUniqueEntityNumber || null,
      companyLegalDoc: legalDocuments.companyLegalDoc
        ? getFileName(legalDocuments.companyLegalDoc)
        : null,
      companyLegalNumber: legalDocuments.companyLegalNumber || null,
      additionalDocuments: compact(legalDocuments.additionalDocuments).map(
        image =>
          isURL(image) ? (getAssetFileNameFromURL(image) as string) : image
      ),
      companyName: legalDocuments.allowCompanyNameEdit
        ? legalDocuments.companyName
        : null,
    },
  };
}

export function buildExistingLegalDocumentVerificationInput(
  document: CompanyVerificationRequestLegalDocument,
  {
    companyName,
    companyUniqueEntityNumber,
  }: {
    companyName?: string | null;
    companyUniqueEntityNumber?: string | null;
  }
): LegalDocumentInput {
  return {
    verificationMethod: VerificationMethod.LEGAL_DOCUMENTS,
    legalDocumentsData: {
      companyNPWPDoc: document.companyNpwpDocument
        ? getFileName(document.companyNpwpDocument)
        : null,
      companyNPWPNumber: document.companyNpwpNumber,
      companyNPWPDocMetadata: pick(document.companyNpwpDocumentMetadata, [
        'source',
        'producer',
        'creator',
        'createdAt',
        'modifiedAt',
      ]),
      companyNIBNumber: document.companyNibNumber || null,
      acraBizFile: document.acraBizFile
        ? getFileName(document.acraBizFile)
        : null,
      companyUniqueEntityNumber:
        companyUniqueEntityNumber || document.companyUniqueEntityNumber,
      companyLegalDoc: document.companyLegalDoc
        ? getFileName(document.companyLegalDoc)
        : null,
      companyLegalNumber: document.companyLegalNumber,
      additionalDocuments: document.additionalDocuments,
      companyName,
    },
  };
}
